import { MapPin, Clock, UsersRound, WalletCards } from 'lucide-react';

interface HomeJobItem {
  id: string;
  title: string;
  timeText: string;
  distanceText: string;
  peopleNeededText: string;
  payText: string;
  tag?: string;
}

interface HomeJobItemCardProps {
  job: HomeJobItem;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const tagStyles: Record<string, string> = {
  '附近': 'bg-green-100 text-green-700',
  '热门': 'bg-orange-100 text-orange-700',
  '急招': 'bg-red-100 text-red-700',
  '周末': 'bg-blue-100 text-blue-700',
};

export function HomeJobItemCard({ job, onClick }: HomeJobItemCardProps) {
  return (
    <article
      onClick={onClick}
      className="flex w-full shrink-0 cursor-pointer flex-col rounded-2xl border border-slate-100 bg-white p-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md sm:w-56"
    >
      <div className="flex items-start justify-between mb-2">
        <h4 className="font-bold text-sm text-slate-950">{job.title}</h4>
        {job.tag && (
          <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${tagStyles[job.tag] || 'bg-slate-100 text-slate-600'}`}>
            {job.tag}
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-2 text-xs text-slate-500">
        <div className="flex items-center gap-1">
          <Clock className="h-3 w-3" />
          <span>{job.timeText}</span>
        </div>
        <div className="flex items-center gap-1">
          <MapPin className="h-3 w-3" />
          <span>{job.distanceText}</span>
        </div>
        <div className="flex items-center gap-1">
          <UsersRound className="h-3 w-3" />
          <span>{job.peopleNeededText}</span>
        </div>
        <div className="flex items-center gap-1">
          <WalletCards className="h-3 w-3 text-emerald-600" />
          <span className="font-semibold text-emerald-600">{job.payText}</span>
        </div>
      </div>
    </article>
  );
}
